import { useTranslations } from '@lang';

export const NumberOfGuests = ({ maximumGuests, minimumGuests, typeName }) => {
  const { t } = useTranslations();
  if (maximumGuests == null && minimumGuests == null) {
    return null;
  }
  return (
    <>
      {maximumGuests !== minimumGuests
        ? t('common.spaTreatmentCanBeBooked', { minimumGuests, maximumGuests, typeName })
        : t('common.spaTreatmentCanBeBookedSingleAmount', {
            guestAmount: maximumGuests,
            typeName,
          })}
    </>
  );
};
